import { TableFieldModel } from '@/model/TableList'

export const businessColumnData: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'unit',
    fieldName: '单位',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'serial',
    fieldName: '序列号',
    width: 80
  },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'urgentName',
    fieldName: '紧急程度',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price',
    fieldName: '原价格',
    isMoney: true,
    textAlign: 'right',
    visible: (data) => {
      const { newPrice } = data
      return newPrice
    },
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'newPrice',
    fieldName: '现价格',
    isMoney: true,
    textAlign: 'right',
    visible: (data) => {
      const { newPrice } = data
      return newPrice
    },
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'price1',
    fieldName: '价格',
    isMoney: true,
    textAlign: 'right',
    convert: ({ rowData }) => rowData.price,
    visible: (data) => {
      const { newPrice } = data
      return !newPrice
    },
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '业务类型',
    width: 100
  }
]
